import React from 'react';
import AdminPanel from '../pages/AdminPanel/AdminPanel';

const AdminRoutes = () => {
  return (
    <AdminPanel />
  );
};

export default AdminRoutes;
